import React from 'react';
import { LoaderStyled, GradientLoaderStyled } from './styles/LoaderStyled';

export const GradientLoader = React.memo(() => {
  return (
    <LoaderStyled>
      <GradientLoaderStyled>
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="20"
            cy="20"
            r="18"
            strokeWidth="4"
            stroke="url(#paint0_linear_13592_67744)"
            strokeLinecap="round"
          />
          <defs>
            <linearGradient
              id="paint0_linear_13592_67744"
              x1="0"
              y1="18.3333"
              x2="23.8818"
              y2="21.5943"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.0632099" stopColor="#227FC3" />
              <stop offset="1" stopColor="#22C3B1" />
            </linearGradient>
          </defs>
        </svg>
      </GradientLoaderStyled>
    </LoaderStyled>
  );
});
GradientLoader.displayName = 'GradientLoader';
